<template>
    <div class="sss_zhuanlan">
        <div class="left">
            <div class="header">
                <div class="user">
                    
                    <img class="avatar"
                         v-if="userInfo.avatar"
                         :src="baseUrl + userInfo.avatar"
                         alt="头像"/>
                    <img class="avatar"
                         v-else
                         src="@/assets/default_avatar.png"
                         alt="头像"/>
                    
                    <div>
                        <div class="name">{{ userInfo.nickname }}（缩水师）</div>
                        <div class="content"
                             style=" margin-top: 12px; line-height: 25px; ">
                            <div>
                                <div>双色球：{{ userInfo.doubleColorBall || 0 }}</div>
                                <div>大乐透：{{ userInfo.lottery || 0 }}</div>
                                <!-- <div class="lastDiv">缩水列表</div> -->
                            </div>
                            <div>
                                <div>福彩3D：{{ userInfo.fucai3d || 0 }}</div>
                                <div>体彩排三：{{ userInfo.pailieSan || 0 }}</div>
                                <!-- <div class="lastDiv">历史成绩</div> -->
                            </div>
                            <div>
                                <div>缩币缩水单：{{ userInfo.payCount || 0 }}</div>
                                <div>免费缩水单：{{ userInfo.freeCount || 0 }}</div>
                                <!-- <div>浏览人数</div> -->
                                <!-- <div class="lastDiv">加入关注</div> -->
                            </div>
                            <div>
                                <!-- <div>粉丝人数</div> -->
                                <!-- <div class="lastDiv">放入桌面</div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="msg">
                    座右铭或者简介：
                    <div> {{ userInfo.motto }}</div>
                </div>
            </div>
            
            <div class="table1">
                <div class="tit">
                    <div>最新预测</div>
                    <span>更多预测</span>
                </div>
                <div class="grid">
                    <div>
                        <span>序号</span>
                        <span>最新缩水预测</span>
                        <span>类型</span>
                        <span>发布时间</span>
                        <span>操作</span>
                    </div>
                    <div v-for="(item,index) in latest_forecast_list" :key="index">
                        <span>{{ index + 1 }}</span>
                        <span style="white-space: nowrap;">{{ handleShrinkageForecast(item) }}</span>
                        <span>{{ item.coin ? '付费' : '免费' }}</span>
                        <span>{{ item.createTime.substr(0, 10) }}</span>
                        <el-button @click="handleDownload(item,item.preIndexType,item.preIndexTypeName,item.preIndexTypeAlies)" type="text" size="small">下载</el-button>
                    </div>
                </div>
            </div>
            <div class="table2">
                <div class="tit">
                    <div>
                        <span>近期成绩</span>
                        <span v-for="(item,index) in lotteryArr"
                              :key="index"
                              :class="{active: index === lotteryActive}"
                              @click="lotteryActive = index">
                            {{ item.title }}
                        </span>
                    </div>
                    <span>更多预测</span>
                </div>
                <div class="grid"
                     v-loading="recent_results_loading">
                    <div :style="['pl3','fc3d'].includes(lotteryArr[lotteryActive].type)?'grid-template-columns: 1fr 2fr repeat(6, 1fr);':''">
                        <span>序号</span>
                        <span>期号/开奖号</span>
                        <span v-for="(item,index) in ys[lotteryArr[lotteryActive].type]" :key="index">{{ item.label }}</span>
                    </div>
                    <div v-for="(item,index) in recent_results_list"
                         :key="index"
                         :style="['pl3','fc3d'].includes(lotteryArr[lotteryActive].type)?'grid-template-columns: 1fr 2fr repeat(6, 1fr);':''">
                        <span>{{ index + 1 }}</span>
                        <span style="flex-direction: column">
                            {{ item.number }}期
                            <b v-html="handleopenNbr(item.openNbr)"></b>
                        </span>
                        <span v-for="(ite,idx) in ys[lotteryArr[lotteryActive].type]" :key="idx" class="sheetItem">
                            <b v-html="jsAttr(item.preChampionVOList,ite.value)"></b>
                        </span>
                    </div>
                </div>
            </div>
        
        </div>
        <div class="right">
            <div v-for="(item,index) in cebian"
                 :key="index">
                <div class="tit">{{ item.title }}</div>
                <ul>
                    <li v-for="(ite,idx) in item.arr"
                        :key="idx"
                        @click="tiaozhuan(ite.name)">
                        {{ ite.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import {getInfo} from "@/api/hangjiaguanli";
import tableMixin from '@/views/homePage/menu/suoshuidan_dating/table/mixin.js'

export default {
    watch: {
        lotteryActive(val) {
            this.recent_achievements()
        }
    },
    mixins: [tableMixin],
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API + '/stage-api',
            userInfo: {},
            
            cebian: [
                {
                    title: "缩水单大厅",
                    arr: [
                        {name: "申请缩水师"},
                        {name: '缩水单大厅双色球半免费区'},
                        {name: '缩水单大厅大乐透半免费区'},
                        {name: '缩水单大厅3D半免费区'},
                        {name: '缩水单大厅排列三半免费区'},
                    ]
                },
                {
                    title: "EXCEL专区",
                    arr: [
                        {name: '申请技巧师'},
                        {name: 'EXCEL专区双色球VIP区'},
                        {name: 'EXCEL专区大乐透VIP区'},
                        {name: 'EXCEL专区3D-VIP区'},
                        {name: 'EXCEL专区排列三VIP区'},
                        {name: '闲置EXCEL改表,修复申请'},
                        {name: '定制EXCEL表申请'},
                    ]
                },
                // {
                //     title: "缩水软件特区",
                //     arr: [
                //         {name: '申请软件交易师'},
                //         {name: '免费软件区'},
                //         {name: '缩水软件VIP区'},
                //         {name: '缩水软件（个人/众筹）定制'},
                //     ]
                // },
                // {
                //     title: "实体投注站帮扶中心",
                //     arr: [
                //         {name: '彩票投注站申请帮扶'},
                //         {name: '彩票代表申请'},
                //         {name: '实战超市（仅限彩票投注站认购）'},
                //         {name: '众筹招股大厅'}
                //     ]
                // },
            ],
            
            // 预测列表
            latest_forecast_list: [],
            
            lotteryArr: [
                {preType: 0, title: '双色球', type: 'ssq'},
                {preType: 1, title: '大乐透', type: 'dlt'},
                {preType: 2, title: '福彩3D', type: 'fc3d'},
                {preType: 3, title: '排列三', type: 'pl3'},
            ],
            lotteryActive: 0,
            
            recent_results_list: [],
            recent_results_loading: false,
            
            ys: {
                ssq: [
                    {label: '90-99.9万', value: 7},
                    {label: '80-89.9万', value: 0},
                    {label: '50-59.9万', value: 1},
                    {label: '15-21.9万', value: 2},
                    {label: '4-4.9万', value: 3},
                    {label: '5005注以下', value: 4},
                    {label: '杀6蓝', value: 5},
                    {label: '围4蓝', value: 6},
                ],
                dlt: [
                    {label: '27-29.9万', value: 7},
                    {label: '20-26.9万', value: 0},
                    {label: '15-17.9万', value: 1},
                    {label: '3-5.9万', value: 2},
                    {label: '1-1.9万', value: 3},
                    {label: '4368注以下', value: 4},
                    {label: '杀5后', value: 5},
                    {label: '围3后', value: 6},
                ],
                fc3d: [
                    {label: '800-899注', value: 5},
                    {label: '700-799注', value: 0},
                    {label: '400-599注', value: 1},
                    {label: '200-399注', value: 2},
                    {label: '50-199注', value: 3},
                    {label: '1-49注', value: 4},
                ],
                pl3: [
                    {label: '800-899注', value: 5},
                    {label: '700-799注', value: 0},
                    {label: '400-599注', value: 1},
                    {label: '200-399注', value: 2},
                    {label: '50-199注', value: 3},
                    {label: '1-49注', value: 4},
                ],
            }
            
        }
    },
    mounted() {
        this.getList()
        
    },
    methods: {
        // 处理最新缩水预测内容
        handleShrinkageForecast(item) {
            const maping = ['双色球', '大乐透', '福彩3D', '排列三']
            return `${maping[item.preType]}第（${item.number}）期${item.preIndexTypeName}指标`
        },
        // 处理近期成绩开奖号样式
        handleopenNbr(openNbr) {
            if(openNbr){
                const splitArr = openNbr.split(' ')
                const start = splitArr.slice(0, splitArr.length - 1);
                const end = splitArr[splitArr.length - 1];
                
                return `
                    <span style="color:#f00"> ${start.join(' ')} </span>
                    +
                    <span style="color:#2899DF">${end}</span>
                `;
            }
        },
        
        jsAttr(arr, val) {
            
            if (arr.length) {
                const targetDb = arr.find(item => item.preIndexType === String(val))
                if(targetDb){
                    const {isWin, isUpdate} = targetDb
                    
                    if(isUpdate === '0'){
                        return `--`
                    }else if(isWin === '1'){
                        return `<b style="color:#2899DF">√</b>`
                    }else{
                        return `<b style="color:#f00">×</b>`
                    }
                    
                }else{
                    return '--'
                }
            }else{
                return `--`
            }
        },
        
        
        tiaozhuan(temp) {
            
            
            const mapping = {
                // 缩水单大厅
                '申请缩水师':'/personalCenter/hangjiaguanli/apply_sss',
                '缩水单大厅双色球半免费区':'/ssddt?caizhong=sss',
                '缩水单大厅大乐透半免费区':'/ssddt?caizhong=dlt',
                '缩水单大厅3D半免费区':'/ssddt?caizhong=3d',
                '缩水单大厅排列三半免费区':'/ssddt?caizhong=pl3',
                
                // EXCEL专区
                '申请技巧师':'/personalCenter/hangjiaguanli/apply_jqs',
                
                'EXCEL专区双色球VIP区':'/excel?caizhong=sss',
                'EXCEL专区大乐透VIP区':'/excel?caizhong=dlt',
                'EXCEL专区3D-VIP区':'/excel?caizhong=3d',
                'EXCEL专区排列三VIP区':'/excel?caizhong=pl3',
                '闲置EXCEL改表,修复申请':'/excel?caizhong=xianzhi',
                '定制EXCEL表申请':'/excel?caizhong=xianzhi',
                
                // 缩水软件特区
                // '申请软件交易师':'/personalCenter/hangjiaguanli/apply_software',
                // '免费软件区':'/software',
                // '缩水软件VIP区':'/software?vip=1',
                // '缩水软件（个人/众筹）定制':'/personalCenter/hangjiaguanli/software_custom',
                
                // 实体投注站帮扶中心
                // '彩票投注站申请帮扶':'/personalCenter/hangjiaguanli/apply_betting_site',
                // '彩票代表申请':'/personalCenter/hangjiaguanli/apply_lottery_representative',
                // '实战超市（仅限彩票投注站认购）':'/personalCenter/hangjiaguanli/apply_real_estate',
                // '众筹招股大厅':'/personalCenter/hangjiaguanli/apply_crowd_funding',
                
            }
            
            this.$router.push(mapping[temp])
            
        },
        getList() {
            getInfo({
                userId: this.vuex_userInfo.userId,
            }).then(res => {
                this.userInfo = res.data;
                this.latest_forecast()
                this.recent_achievements()
            })
        },
        // 预测列表
        latest_forecast() {
            // /stage-api/pre/detail/list
            // /stage-api/pre/detail/getPreRecordList
            this.$http.get('/stage-api/pre/detail/list', {
                params: {
                    createUser: this.vuex_userInfo.userId,
                    pageNum: 1,
                    pageSize: 1000,
                }
            }).then(res => {
                this.latest_forecast_list = res.rows.splice(0, 10)
                console.log('list', this.latest_forecast_list)
                console.log('res', res)
            })
        },
        
        // 近期成绩
        recent_achievements() {
            this.recent_results_list = []
            this.recent_results_loading = true
            this.$http.get('/stage-api/pre/detail/achievmentList', {
                params: {
                    preType: this.lotteryArr[this.lotteryActive].preType,
                    createUser: this.vuex_userInfo.userId,
                }
            }).then(res => {
                this.recent_results_loading = false
                let db = res.rows.splice(0, 20)
                this.recent_results_list = db
            }).catch(err => {
                console.log('err', err);
                this.recent_results_loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.sss_zhuanlan {
    display: flex;
    
    > div {
        border: 1px solid;
    }
    
    .left {
        flex: 1;
        
        .header {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            
            .user {
                display: flex;
                
                .avatar {
                    width: 100px;
                    height: 100px;
                    margin-right: 10px;
                    border: 1px solid red;
                }
                
                > div {
                    flex: 1;
                    
                    .name {
                        color: #bd312a;
                        font-weight: bold;
                    }
                    
                    .content {
                        display: flex;
                        justify-content: space-between;
                        
                        .lastDiv {
                            margin-top: 15px;
                            background-color: #93d2f3;
                            padding: 5px 10px;
                        }
                    }
                }
            }
            
            .msg {
                color: #bd312a;
                margin: 10px 0;
                display: flex;
                
                > div {
                    flex: 1;
                    border-bottom: 1px solid #bd312a;
                }
            }
        }
        
        .table1 {
            .tit {
                display: flex;
                justify-content: space-between;
                background-color: #93d2f3;
                color: #951d1d;
                padding: 5px 10px;
            }
            
            .grid {
                font-size: 12px;
                // height: 300px;
                > div {
                    display: grid;
                    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
                    text-align: center;
                    padding: 10px 0;
                    
                    &:nth-child(odd) {
                        background-color: #f2f2f2;
                    }
                }
            }
        }
        
        .table2 {
            .tit {
                display: flex;
                justify-content: space-between;
                background-color: #93d2f3;
                color: #951d1d;
                padding: 5px 10px;
                
                span {
                    margin-right: 10px;
                    cursor: pointer;
                    
                    &.active {
                        background-color: #951d1d;
                        color: #fff;
                    }
                }
            }
            
            .grid {
                font-weight: bold;
                font-size: 10px;
                min-height: 300px;
                
                > div {
                    display: grid;
                    // grid-template-columns: repeat(10, 1fr);
                    grid-template-columns: 1fr 2fr repeat(8, 1fr);
                    text-align: center;
                    
                    &:nth-child(even) {
                        background-color: #F2F2F2;
                    }
                    
                    span {
                        padding: 5px 0;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        
                        &:first-child {
                            color: blue;
                        }
                    }
                    
                    .sheetItem {
                        font-size: 26px;
                        line-height: 30px;
                    }
                }
            }
        }
    }
    
    .right {
        width: 200px;
        text-align: center;
        
        .tit {
            background-color: #93d2f3;
            color: #951d1d;
            border-bottom: 1px solid #951d1d;
            font-weight: bold;
            font-size: 12px;
            padding: 10px 0;
        }
        
        ul {
            padding: 0;
            margin: 0;
            list-style: none;
            
            li {
                border-bottom: 1px solid #951d1d;
                padding: 10px 0;
                cursor: pointer;
                font-size: 12px;
            }
        }
    }
}
</style>
